angular.module('aprima-provider-api').factory(
    'VersionService', ['AprimaRestangular', 'configuration', '_', '$q', function (AprimaRestangular, configuration, _, $q) {
        'use strict';

        function checkVersions(apiVersions, minVersion){
            var restangular = AprimaRestangular.get();
            var apiCompatible = false,
                clientVersionCompatible = false;

            var validationPromise;

            //for legacy purposes, we can call the server 
            if(!apiVersions || !minVersion){
                validationPromise = $q.all([
                    restangular.one('minclientversion').get(),
                    restangular.all('apiversions').getList()
                ]).then(function(data){
                    clientVersionCompatible = checkMinClientVersion(data[0]);
                    apiCompatible = checkApiCompatibility(data[1]);
                    return clientVersionCompatible && apiCompatible;
                });
            }   
            else{
                var deferred = $q.defer();

                deferred.resolve(checkApiCompatibility(apiVersions) && checkMinClientVersion(minVersion));

                validationPromise = deferred.promise;
            }

            return validationPromise;
        }

        function getServerVersions(){
            var restangular = AprimaRestangular.get();

            return restangular.one('serverversions').get();
        }

        function checkApiCompatibility(apiVersions){
            return _.some(apiVersions, function(api) {
                return api === configuration.SERVER_API_VERSION;
            });
        }

        function checkMinClientVersion(minVersion){
            return checkVersionValid(configuration.CLIENT_VERSION, minVersion);
        }

        function getClientVersion(){
            return configuration.CLIENT_VERSION;
        }

        function checkVersionValid(currentVersion, validVersion){
            if(_.isString(currentVersion)) {
                currentVersion = currentVersion.split('.');
            }

            if(_.isString(validVersion)) {
                validVersion = validVersion.split('.');
            }

            if(!currentVersion)
            {
                currentVersion = validVersion;
            }
            
            var currentVersionLonger = currentVersion.length >= validVersion.length;
            var len = currentVersionLonger ? validVersion.length : currentVersion.length;
            for(var i =0; i < len; i++){
                if(parseInt(currentVersion[i]) > parseInt(validVersion[i]) ){
                    return true;
                }
                else if(parseInt(currentVersion[i]) < parseInt(validVersion[i])){
                    return false;
                }
            }
            return currentVersionLonger;
        }


        return {
            checkVersions: checkVersions,
            checkVersionValid: checkVersionValid,
            getClientVersion: getClientVersion,
            getServerVersions: getServerVersions
        };
    }]);
